/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as actionTypes from './actionTypes';
import {
  arrayMove,
  handleCommaSeparatedAmount,
  handleExistingCommentList,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

export const setUnderThresholdInvoiceSearchTab = (data) => ({
  type: actionTypes.UNDER_THRESHOLD_INVOICE_SEARCH_TAB_DATA,
  searchUnderThInvScreenObj: data,
});

export const selectedIndex = (data)=>({
  type: actionTypes.SELECTED_INDEX,
  selectedIndex: data,
})

export const clearSelectedIndex = ()=>({
  type: actionTypes.CLEAR_SELECTED_INDEX,
})

export const dispatchQuarterData = (data) => ({
  type: actionTypes.GET_QUARTER_DATA_UTI,
  quarter: data,
});
export const setPervSearchListRedux = (data) => {
  return {
    type: actionTypes.PERV_SEARCH_UNDER_TH_INV_DATA,
    perviousUnderThInvSearchRedux: data,
  };
};
export const setSearchScreenTab = (data) => {
  return {
    type: actionTypes.SEARCH_SCREEN_TAB_DATA,
    searchScreenObj: data,
  };
};
export const setDetailsScreenTab = (data) => {
  return {
    type: actionTypes.UNDER_THRESHOLD_INVOICE_DETAILS_TAB_DATA,
    detailsScreenObj: data,
  };
};
export const getQuarterData = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.UNDER_THRESHOLD_INVOICE_GET_MAX_QTR)
    .then((response) => {
      return dispatch(
        dispatchQuarterData(
          response.data && response?.data?.cmsMisMatchQtrResponseVO?.qtr
        )
      );
    })
    .catch(() => {
      dispatch(dispatchQuarterData([]));
    });
};

export const handleErrorMessagesUTI = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_UTI,
  errorMessagesInRedux: data,
});
export const dispatchAuditTypeDropDownList = (data) => ({
  type: actionTypes.GET_AUDIT_TYPE_CD_UTI,
  auditTypeList: data,
});

export const getAuditTypeDropDownList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_AUDIT_TYPE_LIST, value)
    .then((response) => {
      return dispatch(
        dispatchAuditTypeDropDownList(
          response.data && response.data.invoiceAuditResponse
        )
      );
    })
    .catch(() => {
      dispatch(dispatchAuditTypeDropDownList([]));
    });
};
export const getPlanTypeRadioBoxValue = () => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      const tempObj = response.data;
      let updatedArray = [];
      if (tempObj?.PLAN_TYPE_CD?.length > 0) {
        const planArray = tempObj?.PLAN_TYPE_CD;
        planArray.map((element) => {
          if (element?.codeValueID?.codeValue === 'FD') {
            const indexOf = _.findIndex(planArray, element);
            if (!_.isNull(indexOf) && indexOf >= 0) {
              updatedArray = arrayMove(tempObj?.PLAN_TYPE_CD, indexOf, 0);
            }
          }
          return element;
        });
      }
      return updatedArray;
    })
    .catch(() => {
      return [];
    });
};
export const getRebateProgramDropdownList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};
export const dispatchUnderThresholdSearch = (values) => {
  return {
    underThresholdSearchList: values,
    type: actionTypes.GET_UNDER_THRESHOLD_SEARCH_LIST,
  };
};
export const getUnderThresholdSearchRecord = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_UNDER_THRESHOLD_SEARCH_RECORD, value)
    .then((response) => {
      const tempObj = response.data?.data?.map((item, key) => {
        item.key = key;
        item.invoiceHandlingCdErr = false;
        item.isUpdate = false;
        item.totCurrQtrAmt = item.totCurrQtrAmt
          ? handleCommaSeparatedAmount(item.totCurrQtrAmt)
          : `$ ${parseFloat(0).toFixed(2)}`;
        item.invoiceBalance = item.invoiceBalance
          ? handleCommaSeparatedAmount(item.invoiceBalance)
          : `$ ${parseFloat(0).toFixed(2)}`;
        item.retainedAmount = item.retainedAmount
          ? handleCommaSeparatedAmount(item.retainedAmount)
          : `$ ${parseFloat(0).toFixed(2)}`;
        item.accumulatedTotal = item.accumulatedTotal
          ? handleCommaSeparatedAmount(item.accumulatedTotal)
          : `$ ${parseFloat(0).toFixed(2)}`;
        return item;
      });
      return handleExistingCommentList(
        tempObj,
        dispatch,
        dispatchUnderThresholdSearch
      );
    })
    .catch(() => {
      dispatch(dispatchUnderThresholdSearch([]));
    });
};

export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: actionTypes.SAVE_OR_UPDATE,
  };
};
// eslint-disable-next-line consistent-return
export const postSaveOrUpdate = (value) => (dispatch) => {
  if (value === null) {
    dispatch(dispatchSaveOrUpdate(null));
  } else {
    return axios
      .post(serviceEndPoint.UNDER_THRESHOLD_INVOICE_UPDATE_RECORD, value)
      .then((response) => {
        return dispatch(dispatchSaveOrUpdate({...response.data,message:"SUCCESS"}));
      })
      .catch(() => {
        dispatch(dispatchSaveOrUpdate('failed'));
      });
  }
};
export const clearReduxUnderThresholdInvSearchScreen = () => (dispatch) => {
  dispatch(setUnderThresholdInvoiceSearchTab({}));
  dispatch(setSearchScreenTab({}));
  dispatch(handleErrorMessagesUTI([]));
};
export const clearReduxUnderThresholdInvDetailScreen = () => (dispatch) => {
  dispatch(dispatchSaveOrUpdate(''));
  dispatch(setDetailsScreenTab({}));
  dispatch(setPervSearchListRedux({}));
  dispatch(dispatchUnderThresholdSearch([]));
};
